import React from 'react';
import { Link } from "react-router-dom";

import styles from "./HomeHero.module.css";
import templateImage from "./assets/temp.PNG";

import BildungsangeboteSection from "./BildungsangeboteSection";
import AboutSection from "./AboutSection";
import Schnellzugriff from "./Schnellzugriff";
import ValuesSection from "./ValuesSection";
import NewsSection from "./NewsSection";
import DigitalBildung from "./DigitalBildung";

export default function HomeHero() {
  return (
    <div className={styles.homePage}>

      {/* HERO */}
      <section
        className={styles.hero}
        style={{ backgroundImage: `url(${templateImage})` }}
      >
        <div className={styles.overlay}></div>

        <div className={styles.content}>
          <h1>
            Gemeinsam lernen.
            <br />
            Zukunft gestalten.
          </h1>

          <p>
            Willkommen an der IKS – Interkulturelle Schule Rhein-Main.
            Wir fördern Talente, stärken Werte und begleiten unsere Schüler
            auf ihrem Weg in eine erfolgreiche Zukunft.
          </p>

          <div className={styles.buttons}>
            <Link
              to="/bildungsangebote/igsgrundstufe"
              className={styles.btnSecondary}
            >
              Lernen Sie uns kennen!
            </Link>
          </div>
        </div>

        <svg
          className={styles.wave}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path
            fill="#ffffff"
            d="M0,192L60,197.3C120,203,240,213,360,197.3C480,181,600,139,720,138.7C840,139,960,181,1080,192C1200,203,1320,181,1380,170.7L1440,160L1440,320L0,320Z"
          />
        </svg>
      </section>

      {/* SECTIONS */}
      <BildungsangeboteSection />

      <Schnellzugriff />

      <div
        style={{
          backgroundColor: "white",
          width: "100%",
          paddingTop: "50px",
          paddingBottom: "50px",
        }}
      >
        <div
          className="wrapper wrapperContent"
          style={{
            width: "100%",
            marginTop: "40px",
            marginBottom: "40px",
            padding: "30px",
            background: "#fff",
            boxShadow: "0 20px 50px rgba(0,0,0,0.08)",
            overflow: "hidden",
            boxSizing: "border-box"
          }}
        >
          <iframe
            src="https://start.schulportal.hessen.de/kalender.php?i=4393&key=df4f4a99f4ab2513a322425ff1d39b46177f5a5231b1510fdeec4c627322f48cb8597901437cfd1c9cafde2a583198cc&startView=year&notitle=1"
            title="Kalender"
            style={{
              width: "100%",
              height: "60vh",
              border: "none",
              borderRadius: "20px",
              display: "block"
            }}
          />
        </div>
      </div>

      <AboutSection />
      <ValuesSection />
      <NewsSection />
      <DigitalBildung />

    </div>
  );
}